(function () {
    'use strict';

    angular.module('app').controller('NewsController', NewsController);

    NewsController.$inject = [
        '$rootScope',
        '$scope',
        '$routeParams',
        '$location',
        '$filter',
        '$timeout',
        'blockUI',
        'NewsService',
        'CouponsService',
        'LANGS',
        'SelectService',
        'SettingsService',
        '$uibModal'
    ];

    function NewsController(
        $rootScope,
        $scope,
        $routeParams,
        $location,
        $filter,
        $timeout,
        blockUI,
        NewsService,
        CouponsService,
        LANGS,
        SelectService,
        SettingsService,
        $uibModal
    ) {

        $scope.isPageMode = isPageMode;
        $scope.support_news_priority = !!$rootScope.ENV.business.support_news_priority;

        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
        $scope.loyaltyPosList = SelectService.getLPList;
        $scope.multiLang = MultilanguageHelper();
        $scope.onChangeLanguage = onChangeLanguage;
        $scope.getLocalizeField = getLocalizeField;
        $scope.getPages = getTotalPaginatedPages;

        $scope.model = {};

        $scope.data = {
            summaryNews: {},
            newsImage: {
                src: '',
                cropped: '',
                new: false,
                type: ''
            },
            pagers: [10, 20, 50, 100, 200]
        };

        $scope.params = {
            news: {
                page: 1,
                count: 20
            }
        };

        $scope.isURLValid = isURLValid;

        var block_news_list = blockUI.instances.get('news_list');
        var block_news_edit = blockUI.instances.get('news_edit');

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });

        initController();

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Page mode display different parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */
        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        /**
         * Check parameter 'mode' in route ../news/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = 'show';

            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('news_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) {
                $scope._pageMode = 'create';
            }
            ;

            switch ($scope._pageMode) {
                case 'show':
                    _doShow();
                    break;
                case 'create':
                    _doCreate();
                    break;
                case 'edit':
                    _doEdit();
                    break;
            }
        }

        function initmultiLang() {
            $scope.multiLang.initLangs(LANGS, $rootScope.LANG);
        }

        function initController() {
            initmultiLang();
            initPageMode();
        }

        function getNewsCategories() {
            SettingsService.NewsCategories(function (success, data) {
                if (success) {
                    $scope.data.newsCategories = $rootScope.NEWS_CATEGORIES[$rootScope.LANG];
                }
            });
        }

        function onChangeLanguage(new_lang) {
            $scope.multiLang.selected(new_lang);
        };

        function initLocaleStrings(news) {
            $scope.multiLang.initStrings(news, ['title', 'description', 'description_extended']);
        }

        // *********************************************************************************************
        //  SHOW PART
        // *********************************************************************************************

        function _doShow() {
            function s() {
                if ($scope.data.currentLoyalty && $rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.business.tariff.mobile_app_main_page_news) {
                        getNews();
                        $rootScope.TARIFF_LIMITATION.mobile_app_main_page_news = false;
                    } else {
                        $rootScope.TARIFF_LIMITATION.mobile_app_main_page_news = true;
                    }
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        function getNews() {
            var params = {
                count: $scope.params.news.count,
                page: $scope.params.news.page
            };
            if ($scope.support_news_priority) {
                params.sort_by_priority = $scope.support_news_priority;
            }

            params.only_active = !$scope.data.showDisabledItems;

            if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id && $scope.data.currentLoyalty.id !== '0')
                params.loyalty = $scope.data.currentLoyalty.id;

            block_news_list.start();
            NewsService.All(params, function (success, response) {
                if (success) {
                    $scope.data.newsList = $rootScope.NEWS;
                    $scope.data.summaryNews = response.summary;
                }
                block_news_list.stop();
            });
        }

        $scope.isLoyaltyActive = function (news) {
            var l = null;
            if ($rootScope.LOYALTIES && news) {
                l = itemByIndex($rootScope.LOYALTIES, news.loyalty_id);
            }
            return news && news.active && (!l || l.active);
        };

        $scope.onMakeNewsClick = function () {
            $location.path('/news/create');
        };

        $scope.onNewsToggleClick = function (news) {
            var post_data = {
                id: news.id,
                active: 1 * !Boolean(news.active)
            };
            block_news_list.start();
            NewsService.Change(news.id, post_data, function (success, data) {
                if (success) {
                    news.active = post_data.active;
                }
                block_news_list.stop();
            });
        };

        $scope.onPageChange = function (entity) {
            getNews();
        };

        $scope.onChangeShowOnlyActive = function () {
            getNews();
        };

        $scope.onCountChange = function (entity, count) {
            $scope.params.news.page = 1;
            $scope.params.news.count = count;

            getNews();
        };

        // *********************************************************************************************
        //  CREATE & EDIT PART
        // *********************************************************************************************

        $scope.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            var imageType = file.type,
                isPng = imageType === 'image/png';

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {

                    var canvas = document.getElementById('file-canvas'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    canvas.width = width;
                    canvas.height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.drawImage(img, 0, 0, width, height);

                    var resizedImageDataUrl;

                    if (isPng) {
                        resizedImageDataUrl = canvas.toDataURL('image/png');
                    } else {
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', 1);
                    }

                    if (resizedImageDataUrl.length > maxAllowedSize) {
                        var scale = 0.95,
                            quality = 1;

                        do {
                            width = Math.round(img.width * scale);
                            height = Math.round(img.height * scale);

                            canvas.width = width;
                            canvas.height = height;
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            if (isPng) {
                                resizedImageDataUrl = canvas.toDataURL('image/png');
                            } else {
                                quality = Math.max(quality - 0.05, 0.1);
                                resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                            }

                            scale -= 0.05;
                        } while (
                            resizedImageDataUrl.length > maxAllowedSize &&
                            width > 50 && height > 50
                            );
                    }

                    $scope.$apply(function () {

                        $scope.data.newsImage.isGif = false;

                        if (file.type === 'image/gif') {
                            $scope.data.newsImage.cropped = resizedImageDataUrl
                            $scope.data.newsImage.isGif = true;
                        }

                        $scope.data.newsImage.cropped = '';
                        $scope.data.newsImage.loading = false;
                        $scope.data.newsImage.new = true;
                        $scope.data.newsImage.src = resizedImageDataUrl;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        };
        //angular.element('#NewsPicture').on('change', $scope.handleFileSelect);

        $scope.initImgCrop = function () {
            var file = angular.element(document.getElementById('newsPicture'));
            file.on('change', $scope.handleFileSelect);
        };

        $scope.cropNewsImage = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.data.newsImage);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.data.newsImage = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        }

        function initNewNewsPost() {
            $scope.model.news = {
                category_id: '00000000-0000-0000-0000-000000000000',
                type: 'text',
                valid_after: moment().startOf('day').utc().toDate(),
                valid_before: moment().add(1, 'month').utc().toDate(),
                from_time: moment().startOf('day').utc().toDate(),
                to_time: moment().endOf('day').utc().toDate()
            };

            if ($scope.data.currentLoyalty) {
                $scope.model.news.loyalty_id = $scope.data.currentLoyalty.id;
            }

        }

        function _doCreate() {
            initNewNewsPost();

            getNewsCategories();

            $scope.currentLang = $rootScope.LANG;
            initLocaleStrings($scope.model.news);
            if ($scope.data.currentLoyalty) {

                SelectService.getLPList(function (list) {
                    var obj = list.find(function (item) {
                        return item.filter_list_type === 'loyalty' && item.id === $scope.data.currentLoyalty.id;
                        // if ($scope.model.news.pos_id && $scope.model.news.loyalty_id) {
                        //     return (
                        //         item.filter_list_type === 'pos'
                        //         && $scope.model.news.pos_id === item.id
                        //         && $scope.model.news.loyalty_id === item.loyalty_id
                        //     )
                        // } else if ($scope.model.news.loyalty_id) {
                        //     return (
                        //         item.filter_list_type === 'loyalty' && $scope.model.news.loyalty_id === item.id
                        //     )
                        // }

                    });
                    $scope.model.loyalty = obj;
                });
            }
        }

        /**
         * Prepare data for display page in mode 'edit'
         */
        function _doEdit() {
            block_news_edit.start();
            NewsService.Get($routeParams.news_id, function (success, response) {
                if (success) {
                    $scope.model.news = angular.copy(response);

                    $scope.model.news.from_time = moment($scope.model.news.valid_after).toDate();
                    $scope.model.news.to_time = moment($scope.model.news.valid_before).toDate();
                    SelectService.getLPList(function (list) {
                        var obj = list.find(function (item) {
                            if ($scope.model.news.pos_id && $scope.model.news.loyalty_id) {
                                return (
                                    item.filter_list_type === 'pos'
                                    && $scope.model.news.pos_id === item.id
                                    && $scope.model.news.loyalty_id === item.loyalty_id
                                );
                            } else if ($scope.model.news.loyalty_id) {
                                return (
                                    item.filter_list_type === 'loyalty' && $scope.model.news.loyalty_id === item.id
                                );
                            }

                        });
                        $scope.model.loyalty = obj;
                    });
                    // function s() {
                    //     if ($scope.loyaltyPosList) {
                    //
                    //
                    //     } else {
                    //         $timeout(s, 250);
                    //     }
                    // }

                    //s();

                    //$scope.data.currentLoyalty = itemByIndex($scope.data.loyaltiesList, $scope.model.news.loyalty_id);

                    initLocaleStrings($scope.model.news);

                    getCouponBatchesList($scope.model.news.loyalty_id);
                    getNewsCategories();

                    //
                } else {
                    $location.path('/news');
                }
                block_news_edit.stop();
            });
        }

        function getCouponBatchesList(lid) {
            if (!lid) {
                return;
            }
            var params = {
                page: 1,
                count: 500,
                loyalty: lid
            };

            CouponsService.Batches(params, function (success, response) {
                if (success) {
                    var a = response.data;
                    $scope.data.couponBatchesList = [];
                    for (var i in a)
                        if (a[i].active === 1)
                            $scope.data.couponBatchesList.push(a[i]);

                    a = [];
                    if ($scope.model.news.coupon_batches)
                        for (var i in $scope.model.news.coupon_batches)
                            if (itemByIndex($scope.data.couponBatchesList, $scope.model.news.coupon_batches[i].id))
                                a.push(itemByIndex($scope.data.couponBatchesList, $scope.model.news.coupon_batches[i].id));

                    $scope.model.news.coupon_batches = a;
                }
            });
        }

        $scope.onSelectCategory = function (category) {
            console.info('SelectCategory ' + $scope.model.category_id, category);
        };

        $scope.onCancelEdit = function () {
            $location.path('/news');
        };

        $scope.saveNewsChanges = function (form, closeOnSave) {
            function handleRedirect(response) {
                if (closeOnSave)
                    $location.path('/news');
            }

            function handleResult(success, response) {
                if (success) {
                    if ($scope.data.newsImage.new) {
                        var image = $scope.data.newsImage.cropped || $scope.data.newsImage.src;
                        NewsService.UploadPhoto(response.id, image, function (success, upload_response) {
                            if (success) {
                                response.image = upload_response.image;

                                handleRedirect(response);
                            }
                        });
                    } else {
                        handleRedirect(response);
                    }

                    if ($rootScope.NEWS)
                        updateItemInList($rootScope.NEWS.data, response);
                }
                block_news_edit.stop();
            }

            if (isFormValid(form)) {
                block_news_edit.start();

                var post_data = angular.copy($scope.model.news);

                if (post_data.from_time && post_data.to_time) {
                    post_data.valid_after = moment(post_data.valid_after).set({
                        hour: moment(post_data.from_time).get('hour'),
                        minute: moment(post_data.from_time).get('minute'),
                        second: moment(post_data.from_time).get('second')
                    });

                    post_data.valid_before = moment(post_data.valid_before).set({
                        hour: moment(post_data.to_time).get('hour'),
                        minute: moment(post_data.to_time).get('minute'),
                        second: moment($scope.model.to_time).get('second')
                    });
                }
                post_data.valid_after = dtFormat(post_data.valid_after);
                post_data.valid_before = dtFormat(post_data.valid_before);

                var a = [];
                if (post_data.coupon_batches && post_data.coupon_batches.length > 0) {
                    for (var i in post_data.coupon_batches)
                        a.push({id: post_data.coupon_batches[i].id, title: post_data.coupon_batches[i].title});
                }
                post_data.coupon_batches = a;

                switch ($scope._pageMode) {
                    case 'create':
                        NewsService.Create(post_data, handleResult);
                        break;
                    case 'edit':
                        NewsService.Change(post_data.id, post_data, handleResult);
                        break;
                    default:

                }

            }
        };

        var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
            getNewsCategories();
        });

        $scope.$on('$destroy', unbindTranslateChangeSuccess);

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                if ($scope._pageMode === 'show')
                    $scope.data.loyaltiesList.unshift({
                        title: $filter('translate')('All loyalties'),
                        id: '0',
                        active: 1
                    });

                var saved_loyalty;

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                    $scope.data.currentLoyalty = $scope.data.loyaltiesList.find(function (filterItem) {
                        if (filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                            return true;
                        }
                    });
                } else {
                    var index;

                    switch ($scope._pageMode) {
                        case 'show':
                            for (var i in $scope.data.loyaltiesList)
                                if ($scope.data.loyaltiesList[i].id === '0')
                                    $scope.data.currentLoyalty = $scope.data.loyaltiesList[i];
                            break;
                        case 'create':
                            $scope.data.currentLoyalty = getFirstActive($scope.data.loyaltiesList);
                            break;
                    }
                }
            }
        });

        $scope.$watch('data.currentLoyalty', function (newValue, oldValue) {
            if (newValue) {
                switch ($scope._pageMode) {
                    case 'show':
                        _doShow();

                        $rootScope.ENV.filters.news_list = {
                            loyalty_id: newValue.id
                        };

                        $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.id};
                        $rootScope.storeENV();
                        break;
                    case 'create':
                        _doCreate();
                        break;
                }
            }
        }, true);

        $scope.$watch('model.news.loyalty_id', function (newValue, oldValue) {
            if (newValue) {
                getCouponBatchesList($scope.model.news.loyalty_id);
            }
        }, true);
        $scope.$watch('model.loyalty', function (newValue, oldValue) {
            console.log('model.loyalty', newValue);
            if (newValue) {
                if (newValue.filter_list_type == 'pos') {
                    $scope.model.news.loyalty_id = newValue.loyalty_id;
                    $scope.model.news.pos_id = newValue.id;
                } else if (newValue.filter_list_type == 'loyalty') {
                    $scope.model.news.loyalty_id = newValue.id;
                    $scope.model.news.pos_id = null;
                } else {
                    $scope.model.news.loyalty_id = null;
                    $scope.model.news.pos_id = null;
                }
            }
        }, true);

        $rootScope.$watch('LP_LIST', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltyPosList = angular.copy($rootScope.LOYALTIES);

                $scope.data.loyaltyPosList = [];
                for (var i in $rootScope.LP_LIST) {
                    if ($rootScope.LP_LIST[i].filter_list_type === 'loyalty' || $rootScope.LP_LIST[i].filter_list_type === 'pos') {
                        $scope.data.loyaltyPosList.push($rootScope.LP_LIST[i]);
                    }
                }
            }

        });
    }
})();
